lazyframe(".lazyframe", {
  debounce: 250,
  lazyload: true,
  autoplay: true,

  // Callbacks
  onLoad: (lazyframe) => console.log(lazyframe),
  onAppend: (iframe) => console.log(iframe),
  onThumbnailLoad: (img) => console.log(img),
});

import anime from "animejs/lib/anime.es.js";
import Lenis from "lenis";

import imagesLoaded from "imagesloaded";

// Lenis（慣性スクロール）初期化
let lenis;
let scrollVelocity = 0; // 現在のスクロール速度（Lenisのvelocity）
let isMobile = window.innerWidth <= 768; // スマホ判定

function initLenis() {
  lenis = new Lenis({
    lerp: 0.09,
    smoothWheel: true,
    smoothTouch: false, // スマホでは無効化
  });

  lenis.on("scroll", (e) => {
    // e.velocity は -1〜1 程度の相対速度（デバイス/状況で前後）
    scrollVelocity = e.velocity || 0;
  });

  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }
  requestAnimationFrame(raf);
}

// リサイズイベントでデバイス判定を更新
window.addEventListener('resize', () => {
  isMobile = window.innerWidth <= 768;
});

// 後で使用するためのbody要素への参照
const BODY = document.getElementsByTagName("body");

const hbgFunc = () => {
  const header = document.querySelector(".js-header-class");
  const hbg = document.querySelector(".js-hbg");
  const closeHbg = document.querySelectorAll(".js-closeHbg");

  if (!hbg) return;

  hbg.addEventListener(
    "click",
    function (e) {
      e.preventDefault();
      header.classList.toggle("sub-menu-open");
    },
    false,
  );
  closeHbg.forEach((btn) => {
    btn.addEventListener(
      "click",
      function (e) {
        if (!e.target.href.split("#")[1]) e.preventDefault();
        setTimeout(() => {
          header.classList.remove("sub-menu-open");
        }, 600);
      },
      false,
    );
  });
};

function slideInAnimationFunc() {
  const slideInElements = document.querySelectorAll(".js-slide-in");

  // 親要素ごとに .js-slide-in 要素をグループ化
  const groupedElements = {};

  slideInElements.forEach((el) => {
    const parent = el.parentElement;

    // 親要素に一意の識別子を設定
    const parentId = parent.dataset.groupId || `group-${Math.random().toString(36).substr(2, 9)}`;
    if (!parent.dataset.groupId) {
      parent.dataset.groupId = parentId;
    }

    // 親要素IDをキーとしてグループ化
    if (!groupedElements[parentId]) {
      groupedElements[parentId] = [];
    }
    groupedElements[parentId].push(el);
  });

  const observerCallback = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("active");

        const targets = entry.target.querySelectorAll(".letter");

        // 対象の親要素IDから、直下の .js-slide-in 要素の配列を取得
        const parentId = entry.target.parentElement.dataset.groupId;
        const siblings = groupedElements[parentId];
        const index = siblings.indexOf(entry.target); // 現在の要素のインデックス
        const baseDelay = 40; // 基本遅延時間
        const delayTime = baseDelay * index; // インデックスに基づく遅延

        if (entry.target.dataset.effect === "bottom" || entry.target.dataset.effect === "top") {
          anime.timeline().add({
            targets: entry.target,
            scaleY: 1,
            duration: 1800,
            easing: "easeOutExpo",
          });
        } else if (entry.target.dataset.effect === "up") {
          anime.timeline().add({
            targets: entry.target,
            translateY: 0,
            opacity: 1,
            easing: "easeOutExpo",
            duration: 1400,
            delay: delayTime,
          });
        } else {
          anime.timeline().add({
            targets: targets,
            translateY: 0,
            opacity: 1,
            easing: "easeOutExpo",
            duration: 1100,
            delay: (el, i) => delayTime + 30 * i,
          });
        }

        observer.unobserve(entry.target);
      }
    });
  };

  const observerOptions = {
    root: null,
    rootMargin: "-15% 15%",
    threshold: [0, 0.2, 0.3, 0.5, 1],
  };

  const observer = new IntersectionObserver(observerCallback, observerOptions);

  // 各要素を初期化し、Observerを適用
  slideInElements.forEach(function (el) {
    if (el.dataset.effect === "bottom" || el.dataset.effect === "top") {
      anime.set(el, {
        scaleY: 0.1,
      });
    } else if (el.dataset.effect === "up") {
      anime.set(el, {
        opacity: 0,
        // scaleY: 1.2,
        translateY: 20,
      });
    } else {
      el.innerHTML = el.innerHTML.replace(/(<[^>]+>)|(\S)/g, (match, tag, char) => {
        return tag ? tag : `<span class="letter">${char}</span>`;
      });

      anime.set(el.querySelectorAll("span"), {
        opacity: 0,
        translateY: 20,
      });
    }

    observer.observe(el);
  });
}


function scrollAnimation(elem, className) {
  const targets = document.querySelectorAll(elem);

  // Intersection Observerのコールバック関数
  const observerCallback = (entries) => {

    entries.forEach((entry) => {
      anime({
        targets: entry.target.querySelectorAll("img"),
        translateY: 20,
        opacity: 0,
      });
      if (entry.isIntersecting) {
        entry.target.classList.add(className);
        anime({
          targets: entry.target.querySelectorAll("img"),
          translateY: [20, 0],
          opacity: [0, 1],
          easing: "cubicBezier(0.215, 0.61, 0.355, 1)",
          duration: 800,
          delay: anime.stagger(160),
          complete: () => {},
        });
        observer.unobserve(entry.target);
      }
    });
  };

  // Intersection Observerのオプション
  const observerOptions = {
    root: null, // ビューポートをルートとする
    rootMargin: "-15% -10%", // ビューポートの中心を判定基準にする
    threshold: [0, 0.5, 1], // 交差のしきい値
  };

  // Intersection Observerのインスタンスを作成
  const observer = new IntersectionObserver(observerCallback, observerOptions);

  targets.forEach(function (target) {
    observer.observe(target);
  });
}

// リサイズイベントに関数を登録
// window.addEventListener('resize', adjustListItems);

function openingAnimationFunc() {
  const tl = anime.timeline({
    easing: "easeOutExpo",
    duration: 750,
  });
  const kv = document.querySelector(".kv");
  const ftan = kv.querySelector(".js-opening-ftan");
  const bg = kv.querySelector(".kv-bg");

  const imgNum = imagesLoaded("body").images.length; // 読み込んだ画像の数を格納
  let loadedImg = 0; // 現在のプログレス値を格納
  let progressNowPosition = 0;
  const Timer = setInterval(progressMonitor, 1000 / 20);

  imagesLoaded("body").on("progress", () => {
    loadedImg++;
  });

  function progressMonitor() {
    const progressPosition = (loadedImg / imgNum) * 100;
    progressNowPosition += (progressPosition - progressNowPosition) * 0.1;

    if (progressNowPosition >= 80) {
      // oncemodalMovieFunc();
      clearInterval(Timer);
      playAnime();

    }

    const $loadingbarW = Math.round(progressNowPosition * 1.25);


    // イージング計算を完了させる
    if (progressNowPosition > 99.9) {
      progressNowPosition = 100;
    }

    // .add({
    //   targets: '.basic-timeline-demo .el.circle',
    //   translateX: 250,
    // })
    // .add({
    //   targets: '.basic-timeline-demo .el.triangle',
    //   translateX: 250,
    // });

    // startSlider()
    // BODY[0].classList.add('open');
  }

  function playAnime() {
    BODY[0].classList.add("open");
    tl.add({
      targets: ftan,
      translateY: ["30%", 0],
      scale: ["1.3, 0.8", "1,1"],
      opacity: [0, 1],
      easing: "spring(2, 29,  10, 3)",
      duration: 600,
      complete: () => {
        console.log("complete1");
      },
    })
      .add(
        {
          targets: bg,
          translateY: ["20%", 0],
          opacity: [0, 1],
          easing: "cubicBezier(0.215, 0.61, 0.355, 1)",
          duration: 1200,
          complete: () => {
            console.log("complete2");
          },
        },
        "1200",
      )
      .add(
        {
          targets: ".header",
          translateY: ["-120%", 0],
          opacity: [0, 1],
          easing: "cubicBezier(0.215, 0.61, 0.355, 1)",
          duration: 1200,
          complete: () => {
            console.log("complete3");
            BODY[0].classList.add("open");
            // startSlider()
          },
        },
        "1600",
      )
      .add(
        {
          targets: ".header",
          complete: () => {
            console.log("complete4");
            BODY[0].classList.add("animation");
          },
        },
        "1100",
      );
  }
}

// 対象の要素を取得
const targetElement = document.querySelector(".js-header-class");

if (targetElement) {
  // MutationObserverのコールバック関数
  const observerCallback = (mutationsList) => {
    mutationsList.forEach((mutation) => {
      if (mutation.type === "attributes" && mutation.attributeName === "class") {
        // js-header-classにsub-menu-openがある場合、bodyにopenを追加
        if (targetElement.classList.contains("sub-menu-open")) {
          document.body.classList.add("open2");
        } else {
          document.body.classList.remove("open2");
        }
      }
    });
  };

  // MutationObserverの設定
  const observer = new MutationObserver(observerCallback);

  // 対象の要素に対して監視を開始
  observer.observe(targetElement, { attributes: true });
}


let lastScrollTop = 0;

// Intersection Observer APIを使用して.kvが画面内に入った場合に処理を行う
const kvElement = document.querySelector(".kv");
if (kvElement) {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          document.body.classList.add("inside-kv");
        } else {
          document.body.classList.remove("inside-kv");
        }
      });
    },
    {
      threshold: 0.1, // 要素の10%が見えるときにコールバック
    },
  );
  observer.observe(kvElement);
}

// スクロールイベントリスナー
window.addEventListener("scroll", () => {
  // リクエストアニメーションフレームを使用して負荷を軽減
  window.requestAnimationFrame(() => {
    const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (currentScrollTop < lastScrollTop) {
      // 上にスクロールしているときにopenを付ける
      document.body.classList.add("open");
    } else {
      // 下にスクロールしているときにopenを削除
      document.body.classList.remove("open");
    }

    lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop; // Safariの負のスクロール値を防ぐ
  });
});

// 無限スライド（RAFベース）
function initInfiniteScroll() {
  const slideContainers = document.querySelectorAll('.slide-wrap ul');
  if (!slideContainers.length) return;

  // 各スライダーの状態を保持
  const sliders = [];

  slideContainers.forEach((slideContainer) => {
    const originalItems = Array.from(slideContainer.children);
    const state = {
      el: slideContainer,
      x: 0,
      baseWidth: 0,
      inView: false,
      initialized: false,
    };

    // セットアップ（1セット幅を基準に、合計が十分になるまで複製）
    const setup = () => {
      if (state.initialized) return;
      // まず現在の幅を1セット幅とみなす
      const singleWidth = slideContainer.scrollWidth;
      if (singleWidth === 0) return; // レイアウト未確定時の保護

      // 合計幅が 1セット×4 になるまで複製
      while (slideContainer.scrollWidth < singleWidth * 4) {
        originalItems.forEach((item) => {
          slideContainer.appendChild(item.cloneNode(true));
        });
      }

      state.baseWidth = singleWidth; // 1セット分でループする
      state.initialized = true;
    };

    // 画像読み込み完了後に確実にセットアップ
    imagesLoaded(slideContainer, setup);
    // 既に読み込み済みなら即実行
    setup();

    sliders.push(state);
  });

  // 画面内/外の監視
  const io = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const el = entry.target.querySelector('ul') || entry.target; // .slide-wrap か ul
      const s = sliders.find((sl) => sl.el === el);
      if (!s) return;
      s.inView = entry.isIntersecting;
    });
  }, { root: null, threshold: 0.01 });

  // .slide-wrap を監視対象に
  document.querySelectorAll('.slide-wrap').forEach((wrap) => io.observe(wrap));

  // 単一のRAFで全て更新。デバイスに応じて速度制御
  const BASE_SPEED = 0.9; // 基本速度（px/frame相当）
  function tick() {
    sliders.forEach((s) => {
      if (!s.inView || s.baseWidth === 0) return;

      if (isMobile) {
        // スマホでは一定速度（常に左方向）
        const speed = BASE_SPEED;
        s.x -= speed;
      } else {
        // PCではLenis velocityと連動（常に左方向）
        const v = BASE_SPEED * (1 + Math.abs(scrollVelocity) * 0.3) * Math.sign(scrollVelocity || 1);
        s.x -= v;
      }

      if (-s.x >= s.baseWidth) s.x = 0;
      s.el.style.transform = `translate3d(${s.x}px,0,0)`;
    });
    requestAnimationFrame(tick);
  }
  requestAnimationFrame(tick);
}

// DOMが完全にロードされたらbodyに'open'クラスを追加
document.addEventListener("DOMContentLoaded", () => {
  if (BODY[0].classList.contains("open")) return;

  initLenis();
  hbgFunc();
  slideInAnimationFunc();
  scrollAnimation(".js-about-ftan", "showing");
  initInfiniteScroll();
});
